import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';

import authAtom from '~/recoil/atom/auth';

import { PLATFORM_ID } from '~/globalVariables';

import updatePlatformCustomer from '~/firebase/update/updatePlatformCustomer';
import { platformCustomerListener } from '~/firebase/listeners/platform';
import { SnapshotFn } from '~/firebase/listeners/type';

import { Customer } from '~/types/platform/customer';

export default function useCustomer() {
  const auth = useRecoilValue(authAtom);
  const [maskedId, setMaskedId] = useState<string>('');

  const handleCustomerListener: SnapshotFn = async (doc) => {
    if (doc.exists()) {
      const customer = doc.data() as Customer;
      setMaskedId(customer.tzWallet?.maskedId || '');
    } else {
      setMaskedId('');
    }
  };

  const handleRemoveTzWallet = async () => {
    if (auth) {
      await updatePlatformCustomer(PLATFORM_ID, auth, {
        tzWallet: { maskedId: '', chRfidCode: '' },
      });
    }
  };

  useEffect(() => {
    if (auth) {
      const unlisten = platformCustomerListener(PLATFORM_ID, auth.uid, handleCustomerListener);
      return () => {
        unlisten();
      };
    }
  }, [auth]);

  return {
    maskedId,
    handleRemoveTzWallet,
  };
}
